export interface KeyMilestoneGroup {
  key: 'tender' | 'input' | 'finance' | 'tech';
  itemName: string;
  legacyNames: string[];
  milestoneType: string;
  milestones: string[];
}

export const KEY_MILESTONE_GROUPS: KeyMilestoneGroup[] = [
  {
    key: 'tender',
    itemName: 'Mốc thầu',
    legacyNames: [],
    milestoneType: 'event_tender',
    milestones: ['Kick-off', 'Thống nhất trước nộp', 'Nộp thầu'],
  },
  {
    key: 'input',
    itemName: 'Mốc phê duyệt',
    legacyNames: ['Đầu vào'],
    milestoneType: 'event_input',
    milestones: ['LOA', 'Permit_BM', 'duyệt shop-specs Fit-out MEP', 'duyệt shop-specs Long lead', 'duyệt shop-specs Hoàn thiện'],
  },
  {
    key: 'finance',
    itemName: 'Mốc thu chi',
    legacyNames: ['Tài chính'],
    milestoneType: 'event_finance',
    milestones: ['Plan Thu & Chi', 'Mốc claim giai đoạn', 'Mốc claim quyết toán', 'Mốc chi gói lớn & gói longlead'],
  },
  {
    key: 'tech',
    itemName: 'Mốc kiểm tra',
    legacyNames: ['Kỹ thuật'],
    milestoneType: 'event_tech',
    milestones: ['Marking sàn', 'KC âm vách', 'KC âm trần', 'Lắp đặt nội thất & hoàn thiện cuối', 'Kiểm tra vận hành', 'Hồ sơ Quyết toán'],
  },
];

/** Nhóm mốc của 1 item — CÙNG quy tắc với guard nút tạo nhóm mốc:
 *  category = Event (không phân biệt hoa/thường) VÀ tên khớp itemName hoặc 1 trong legacyNames.
 *  Trả undefined nếu item không phải nhóm mốc. */
export function keyGroupForItem(
  item: { name?: string | null; category?: string | null } | null | undefined,
): KeyMilestoneGroup | undefined {
  if (!item || (item.category ?? '').toLowerCase() !== 'event') return undefined;
  const n = item.name ?? '';
  return KEY_MILESTONE_GROUPS.find(g => g.itemName === n || g.legacyNames.includes(n));
}
